export default __webpack_public_path__ + "static/media/Personal.9d13b75e.jpeg";